import projection from '../generated/pwp203f1.json';
import { AcceptanceManifest } from '../types';

export const pwp203f1AcceptanceManifest = projection as AcceptanceManifest;
